import * as React from 'react';
import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={11} height={11} fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g clipPath="url(#clip0_11249_32821)">
      <path
        d="M1.5885 7.57957L4.40916 1.8207C4.93173 0.753778 6.45248 0.753778 6.97506 1.8207L9.79568 7.57957C9.91925 7.83171 10.0177 8.11485 9.76596 8.31543C8.58268 9.25857 2.80151 9.25857 1.61823 8.31543C1.36621 8.11457 1.46368 7.83435 1.5885 7.57957Z"
        fill="white"
        stroke="#FF0000"
        strokeLinejoin="round"
      />
      <path
        d="M5.69531 3.66504V5.45075M5.69531 7.0579V7.23647"
        stroke="#FF0000"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_11249_32821">
        <rect width="10" height="10" fill="white" transform="translate(0.695312 0.09375)" />
      </clipPath>
    </defs>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const IconRedWarning = memo(ForwardRef);
export default IconRedWarning;
